<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    class="heroicon-news heroicon heroicons-lg"
  >
    <path
      class="heroicon-news-paper heroicon-component-fill"
      fill="#FFFFFF"
      d="M88.59 12.59L88 12V8l-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2v79a6 6 0 0 0 6 6h87a7 7 0 0 0 7-7V20l-.59.59L98 22l-.59-.59-.82-.82L96 20v-4l-.59.59L94 18l-.59-.59-.82-.82L92 16v-4l-.59.59L90 14l-.59-.59-.82-.82z"
    ></path>
    <polygon
      class="heroicon-news-top-image heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      points="9 43 9 25 79 25 79 43"
    ></polygon>
    <polygon
      class="heroicon-news-bottom-image heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      points="41 54 9 54 9 84 41 84"
    ></polygon>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M93 91a4.99 4.99 0 0 1-4-2h4a3 3 0 0 0 3-3V22.83l.59.58L98 24.83V86a5 5 0 0 1-5 5zm-2.83-4H88.1c-.07-.32-.1-.66-.1-1V14.83l.59.58L90 16.83V86a3 3 0 0 0 .17 1zM93 87a1 1 0 0 1-1-1V18.83l.59.58L94 20.83V86a1 1 0 0 1-1 1z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      d="M88.59 12.59l.82.82.59.59 1.41-1.41L92 12v4l.59.59.82.82.59.59 1.41-1.41L96 16v4l.59.59.82.82.59.59 1.41-1.41.59-.59v66a7 7 0 0 1-7 7H6a6 6 0 0 1-6-6V8l2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2v4l.59.59zM93 91a5 5 0 0 0 5-5V24.83l-1.41-1.42-.59-.58V86a3 3 0 0 1-3 3h-4a5.05 5.05 0 0 0 4 2zm-2.83-4a3 3 0 0 1-.17-1V16.83l-1.41-1.42-.59-.58V86c0 .34.03.68.1 1h2.07zM86 12.83l-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2V87A4 4 0 0 0 6 91h82.1a7.02 7.02 0 0 1-2.1-5V12.83zM93 87a1 1 0 0 0 1-1V20.83l-1.41-1.42-.59-.58V86a1 1 0 0 0 1 1zM8 24h72v20H8V24zm1 19h70V25H9v18zm0 10h33v32H8V53h1zm32 1H9v30h32V54zm39-1v1H46v-1h34zm-34 3h34v1H46v-1zm0 5v-1h16v1H46zm16 2v1H46v-1h16zm0 4H46v-1h16v1zm0 2v1H46v-1h16zm0 4H46v-1h16v1zm0 2v1H46v-1h16zm0 4H46v-1h16v1zm18-19v1H64v-1h16zm0 4H64v-1h16v1zm0 2v1H64v-1h16zm0 4H64v-1h16v1zm0 2v1H64v-1h16zm0 4H64v-1h16v1zm0 2v1H64v-1h16zm-18 4H46v-1h16v1zm18-1v1H64v-1h16zm-18 4H46v-1h16v1zm18-1v1H64v-1h16zm0-65v1H8v-1h72zM8 48h72v1H8v-1z"
    ></path>
  </svg>
</template>
